import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { Eye } from 'styled-icons/fa-solid/Eye';
import { EyeSlash } from 'styled-icons/fa-solid/EyeSlash';
import Text from '../../text';
import { Col, Row } from '../../layout';
import FONT from '../../font';

const InputWrapper = styled.div`
  position: relative;
  margin-top: 8px;
`;
const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 14px;
  color: ${({ theme: { COLORS } }) => COLORS.GRAY};
`;
const StyledInput = styled.input`
  width: 100%;
  height: 42px;
  line-height: 14px;
  border: 1px solid #bac0c3;
  border-radius: 4px;
  outline: none;
  font-family: ${FONT.FAMILY};
  font-size: 14px;
  padding: 14px;
  padding-right: ${({ toggleEnabled }) => (toggleEnabled ? 52 : 14)}px;

  :focus {
    border-color: ${({ theme: { COLORS } }) => COLORS.SKY_DARK};
  }
`;

export default class PasswordInput extends PureComponent {
  static defaultProps = {
    toggleEnabled: false,
    label: null,
    placeholder: '',
    error: null,
    onChange: () => {},
  };

  static propTypes = {
    toggleEnabled: PropTypes.bool,
    label: PropTypes.string,
    error: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
  };

  state = {
    type: 'password',
  };

  onChange = e => {
    const { onChange } = this.props;

    onChange(e.target.value, e);
  };

  toggleInputType = () => {
    this.setState(({ type }) => ({
      type: type === 'password' ? 'text' : 'password',
    }));
  };

  renderEye() {
    const { type } = this.state;
    return (
      <ToggleWrapper>
        {type === 'password' ? (
          <Eye size={24} onClick={this.toggleInputType} />
        ) : (
          <EyeSlash size={24} onClick={this.toggleInputType} />
        )}
      </ToggleWrapper>
    );
  }

  render() {
    const { label, error, onChange, toggleEnabled, ...others } = this.props;
    const { type } = this.state;

    return (
      <label>
        <Row>
          <Col>
            <Text size="small" precise>
              {label}
            </Text>
          </Col>
          {error && (
            <Col autoRight>
              <Text size="small" type="negative" precise>
                {error}
              </Text>
            </Col>
          )}
        </Row>
        <InputWrapper>
          <StyledInput
            toggleEnabled={toggleEnabled}
            onChange={this.onChange}
            {...others}
            type={type}
          />
          {toggleEnabled && this.renderEye()}
        </InputWrapper>
      </label>
    );
  }
}
